import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Auth from "./pages/Auth";
import Checkout from "./pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Wishlist from "./pages/Wishlist";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Lookbook from "./pages/Lookbook";
import About from "./pages/About";
import Journal, { JournalPost } from "./pages/Journal";
import ShippingReturns from "./pages/ShippingReturns";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Wellness from "./pages/Wellness";
import WellnessQuiz from "./pages/WellnessQuiz";
import GiftCard from "./pages/GiftCard";

function App() {
  return (
    <div className="App bg-[#FAF8F5] min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Header />
            <CartDrawer />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/signup" element={<Auth mode="signup" />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/lookbook" element={<Lookbook />} />
                <Route path="/about" element={<About />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalPost />} />
                <Route path="/shipping-returns" element={<ShippingReturns />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/wellness" element={<Wellness />} />
                <Route path="/reconnect" element={<Wellness />} />
                <Route path="/wellness/quiz" element={<WellnessQuiz />} />
                <Route path="/reconnect/quiz" element={<WellnessQuiz />} />
                <Route path="/gift/:token" element={<GiftCard />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "Outfit" } }} />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
